<template>
    <div class="thesaurus">
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
            :breadcrumb="{ props: { routes } }"
        />

        <div class="thesaurus-detail">
            <a-card>
                <div>
                    <div class="search  push-search">
                        <div class="left">
                            <label for="">关键词：</label>
                            <a-input placeholder="" style="width:200px;margin-right:16px"/>
                            <label for="">来源：</label>
                            <div>
                                <a-select default-value="all" style="width: 200px" >
                                    <a-select-option value="all">
                                        全部
                                    </a-select-option>
                                    <a-select-option value="system">
                                        系统
                                    </a-select-option>
                                    <a-select-option value="jack">
                                        手动
                                    </a-select-option>
                                </a-select>
                            </div>
                            <a-button type="primary">查询</a-button>
                            <a-button type="primary" @click="addsingleshow">添加关键词</a-button>
                            <a-button type="primary" @click="addbatchshow">批量添加关键词</a-button>
                            <a-button type="primary">导出关键词</a-button>
                        </div>
                        <div class="right">
                            <a-button type="primary">刷新</a-button>
                        </div>
                    </div>

                    <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                    >

                        <span slot="action">
                            <a href="javascript:;"  @click="showDeleteConfirm"><a-icon type="delete"/>删除</a>
                        </span>
                    </a-table>
                </div>
            </a-card>
        </div>

        <!-- 提交关键词 -->
        <a-modal
        title="添加关键词"
        cancelText="取消"
        okText="确定"
        width="400px"
        :visible="addsingle"
        :confirm-loading="confirmLoading"
        @ok="single"
        @cancel="handleCancel"
        >
            <a-input placeholder=""/>
        </a-modal>

        <!-- 批量提交关键词 -->
        <a-modal
        cancelText="取消"
        okText="确定"
        width="400px"
        title="批量添加关键词"
        :visible="addbatch"
        :confirm-loading="confirmLoading"
        @ok="batch"
        @cancel="handleCancel"
        >
            <a-textarea placeholder="请添加关键词，每个关键词一行，或者以空格隔开" :rows="4" />
        </a-modal>


    </div>
</template>

<script>

import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '来源',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '关键词',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '等级',
    key: 'tags',
    dataIndex: 'tags',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: '钢化玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'未读',
    money:'26',
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: '阳台玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'已读',
    money:'3.2',
  },
];

export default {
    data(){
        return{
            data,
            locale,
            columns,
            addsingle:false,
            addbatch:false,
            confirmLoading: false,
            pagination: {},
            loading: false,
            routes: [
                {breadcrumbName: '首页'},
                {path:'home',breadcrumbName: '排名查询'},
                {path:'nranking',breadcrumbName: '自然排名'},
                {breadcrumbName: '词库管理'},
            ],
        }
    },
    methods:{
        handleCancel(e) {
            this.addsingle = false;
            this.addbatch = false;
        },
        addsingleshow(){
            this.addsingle = true;
        },
        addbatchshow(){
            this.addbatch = true;
        },
        batch(){
            this.confirmLoading = true;
            setTimeout(() => {
                this.addbatch = false;
                this.confirmLoading = false;
            }, 2000);
        },
        single(){
            this.confirmLoading = true;
            setTimeout(() => {
                this.addsingle = false;
                this.confirmLoading = false;
            }, 2000);
        },
        showDeleteConfirm() {
            Modal.confirm({
                title: '提示',
                content: '确定删除该关键词？',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:()=> {
        
                },
                onCancel() {

                },
            });
        },
        onChange(date, dateString) {
            console.log(date, dateString);
        },
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/thesaurus/index.vue